module.exports = __webpack_public_path__ + "./fonts/c05f7486a019217f894d9a844cd97d4b.woff2";